export const getStatusBadgeColor = (status: string): string => {
  switch (status) {
    case 'paid':
      return 'bg-[var(--success-bg)] text-[var(--success)]';
    case 'pending':
      return 'bg-yellow-100 text-yellow-800';
    case 'draft':
      return 'bg-gray-100 text-gray-800';
    case 'cancelled':
    case 'invalidated':
      return 'bg-[var(--error-bg)] text-[var(--error)]';
    case 'partially_paid':
      return 'bg-blue-100 text-blue-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getPaymentStatusBadgeColor = (status: string): string => {
  switch (status) {
    case 'completed':
      return 'bg-[var(--success-bg)] text-[var(--success)]';
    case 'refunded':
      return 'bg-yellow-100 text-yellow-800';
    case 'chargeback':
      return 'bg-[var(--error-bg)] text-[var(--error)]';
    case 'failed':
      return 'bg-gray-100 text-gray-800';
    case 'pending':
      return 'bg-blue-100 text-blue-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
